import { compose } from 'recompose';
import { themr } from '@friendsofreactjs/react-css-themr';

import ModalHeaderComponent from './ModalHeader';
import intlEquipped from '../../../hocs/intlEquipped';

const ModalHeader = compose(
    themr('ModalHeader'),
    intlEquipped
)(ModalHeaderComponent);

export default ModalHeader;
